/* Reducers */
import Auth from "./auth/reducer";
import App from "./app/reducer";
import ThemeSwitcher from "./themeSwitcher/reducer";
import initial from "./initial/reducer";
import Seguros from "./DTRedux/reducers";
import SegurosCC from "./seguros_coberturacompleta/reducers";
import CCReducer from "./CCRedux/reducers";
import CTCReducer from "./CTCRedux/reducers";
import CampaignReducer from "./campaign/reducers";
import TaxisReducer from "./TaxiRedux/reducers";

export default {
  Auth,
  App,
  ThemeSwitcher,
  initial,
  Seguros,
  SegurosCC,
  CCReducer,
  CTCReducer,
  CampaignReducer,
  TaxisReducer,
};
